import { render, staticRenderFns } from "./VueInputRestricted.vue?vue&type=template&id=36eecdc4&scoped=true&"
import script from "./VueInputRestricted.vue?vue&type=script&lang=js&"
export * from "./VueInputRestricted.vue?vue&type=script&lang=js&"
import style0 from "./VueInputRestricted.vue?vue&type=style&index=0&id=36eecdc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eecdc4",
  null
  
)

export default component.exports